import { ComponentItemWithData } from "../..";

const RenderErrorCard = (
  component: ComponentItemWithData,
  index: number,
  className: string
) => (
  <div key={component.id} className={`${className} error`} data-index={index}>
    <div className="error-message">
      Configuration not found: {component.module}.{component.configKey}
    </div>
  </div>
);

export default RenderErrorCard;
